import React, { useState, useRef, useEffect } from 'react';
import { string, oneOf, func, bool } from 'prop-types';
import { ProductAddOnsPod } from '../../common/product-add-ons-pod';
import { ICONS } from '../../../utils/product-add-on-constants';
import { ProtectionPlanTooltip } from './ProtectionPlanTooltip';

export const HomeDepotProtectionPlan = ({
  itemId,
  channel,
  term,
  price,
  onChange,
  url
}) => {

  const [isHdppSelected, setIsHdppSelected] = useState(false);
  const tooltipButtonRef = useRef(null);
  const iconUrl = ICONS.hdpp;
  /** Props for checkbox component */
  const userOptions = [{
    id: itemId,
    value: 'hdpp-accept',
    label: `${term} Year / `,
    price,
    checked: isHdppSelected,
  },
  {
    value: 'hdpp-decline',
    label: 'No thanks',
    checked: !isHdppSelected
  }];

  const handleChange = (evt) => {
    const userSelectedHdpp = evt.target.value === 'hdpp-accept';
    const eventData = {
      target: {
        value: 'hdpp'
      }
    };

    // This is temp, will be refactored once checkbox comp gets updated
    if (userSelectedHdpp && !isHdppSelected) {
      eventData.target.checked = true;
      LIFE_CYCLE_EVENT_BUS.trigger('hdpp.change', { isOptedIn: true, itemId });
      onChange(eventData, { data: { itemId } });
      setIsHdppSelected(true);
    } else if (!userSelectedHdpp && isHdppSelected) {
      eventData.target.checked = false;
      LIFE_CYCLE_EVENT_BUS.trigger('hdpp.change', { isOptedIn: false, itemId });
      onChange(eventData, { data: { itemId } });
      setIsHdppSelected(false);
    }
  };

  useEffect(() => {
    const tippy = tooltipButtonRef?.current?._tippy;
    if (tippy) tippy.hide();
  }, [isHdppSelected]);

  const tooltip = (
    <ProtectionPlanTooltip
      channel={channel}
      url={url}
      ref={tooltipButtonRef}
    />
  );

  return (
    <ProductAddOnsPod
      heading="Protect This Item"
      subHeading="Select a Home Depot Protection Plan for:"
      tooltip={tooltip}
      userOptions={userOptions}
      icon={iconUrl}
      iconHeight={47}
      onChange={handleChange}
      channel={channel}
      radio
    />
  );
};

HomeDepotProtectionPlan.displayName = 'productAddOns-homeDepotProtectionPlan';

HomeDepotProtectionPlan.propTypes = {
  /** Device Type: Mobile or Desktop */
  channel: oneOf(['desktop', 'mobile']),
  /** protection plan price */
  price: string.isRequired,
  /** protection plan term length */
  term: string,
  /** handler for select or unselect hdpp */
  onChange: func.isRequired,
  /** protection plan item id */
  itemId: string.isRequired,
  /** url for plan details */
  url: string
};

HomeDepotProtectionPlan.defaultProps = {
  channel: 'desktop',
  term: '',
  url: ''
};